import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";

function init() {
    setEvents();
}
function setEvents() {
    // button on the _AddSiteProgram form
    $(document).on("click", "#addProgrambtn", function() {
        if (!$("#AddProgramSelect").val()) {
            $("#programError").removeClass("hidden");
        } else {
            const programId = $("#AddProgramSelect").val();
            const siteId = $("#siteId").val();
            // Name of tabpanel on Index Page
            const container = $("#programs");

            $("#addSiteProgram .close").click();
            dataaccess.post({ url: "/api/site/" + siteId + "/addprogram", data: programId, successMsg: "Successfully assigned program." }).done(function(data) {
                container.html(data);
            });
        }
    });

    $(document).on("click", "#addSiteProgramBtn", function() {
        if ($("#AddProgramSelect option").length === 1) {
            let programs;
            const ids = $("#programTable > tbody > tr")
                .map(function() {
                    return parseInt($(this).attr("programId"));
                })
                .get();
            dataaccess.get({ url: "/api/programs/programsforsite" }).done(function(result) {
                programs = result;
                for (let i = 0; i < programs.length; i++) {
                    if (!ids.includes(parseInt(programs[i].id))) {
                        const programName = programs[i].name;
                        $("#AddProgramSelect").append(
                            `<option value='${programs[i].id}'>${programName}</option>"`
                        );
                    }
                }
            });
        }
    });
}

export const addSiteProgram = {
    init: init
};
